/* eslint-env jest */
import {
  extractScodeFromPoseUrl,
  announcementThumbUrlForScode,
  announcementThumbUrlForPose,
} from './announcementThumbnail';

// Pose watermark URLs put the school code at the start of the filename,
// zero-padded (e.g. "069-s...") and followed by "-s" (senior) or "-e" (elementary).
// We want the scode without leading zeros and with no ambiguity between
// e.g. 19 and 195 (which the old substring-match code was fragile about).
describe('extractScodeFromPoseUrl', () => {
  it('extracts the scode from a signed senior pose URL', () => {
    const url = 'https://shoobphoto.s3.us-west-1.amazonaws.com/images/watermarks/seniors/1584999/original/069-s081e-R878953673197-11.png?X-Amz-Signature=abc';
    expect(extractScodeFromPoseUrl(url)).toBe('69');
  });

  it('extracts the scode from an elementary pose URL', () => {
    const url = 'https://shoobphoto.s3.us-west-1.amazonaws.com/images/watermarks/poses/4339913/original/136-e001x-500351';
    expect(extractScodeFromPoseUrl(url)).toBe('136');
  });

  it('does not confuse scode 19 with scode 195', () => {
    const url195 = 'https://s3.example/some/path/195-s001-anything.png';
    const url19 = 'https://s3.example/some/path/19-s001-anything.png';
    expect(extractScodeFromPoseUrl(url195)).toBe('195');
    expect(extractScodeFromPoseUrl(url19)).toBe('19');
  });

  it('returns null when the URL is missing or unparseable', () => {
    expect(extractScodeFromPoseUrl(null)).toBeNull();
    expect(extractScodeFromPoseUrl(undefined)).toBeNull();
    expect(extractScodeFromPoseUrl('')).toBeNull();
    expect(extractScodeFromPoseUrl('https://example.com/no-scode.jpg')).toBeNull();
  });
});

describe('announcementThumbUrlForScode', () => {
  it('builds the S3 URL for a school scode', () => {
    expect(announcementThumbUrlForScode('546')).toBe(
      'https://shoobphoto.s3.us-west-1.amazonaws.com/assets/graphics/Seniors/546_Traditional%20Logo%20Announcement.jpg',
    );
  });

  it('returns null when no scode is given', () => {
    expect(announcementThumbUrlForScode(null)).toBeNull();
    expect(announcementThumbUrlForScode('')).toBeNull();
  });
});

describe('announcementThumbUrlForPose', () => {
  it('resolves a pose URL to the correct thumbnail URL', () => {
    const url = 'https://s3.example/path/546-s001-abc.png';
    expect(announcementThumbUrlForPose(url)).toBe(
      'https://shoobphoto.s3.us-west-1.amazonaws.com/assets/graphics/Seniors/546_Traditional%20Logo%20Announcement.jpg',
    );
  });

  it('returns null when the pose URL has no scode', () => {
    expect(announcementThumbUrlForPose(null)).toBeNull();
  });
});
